import { Sparkles, Clock, Target } from "lucide-react"

import { FeatureCard } from "./feature-card"
import { Progress } from "@/components/ui/progress"
import type { DashboardFlashcardsStats } from "@/types"

interface FlashcardsCardProps {
  stats: DashboardFlashcardsStats
  animationDelay?: number
}

export function FlashcardsCard({
  stats,
  animationDelay = 0,
}: FlashcardsCardProps) {
  const masteryPercentage =
    stats.totalCount > 0
      ? Math.round((stats.masteredCount / stats.totalCount) * 100)
      : 0

  return (
    <FeatureCard
      title="Flashcards"
      icon={Sparkles}
      iconColor="text-violet-600 dark:text-violet-400"
      iconBgColor="bg-violet-100 dark:bg-violet-900/30"
      href="/flashcards"
      animationDelay={animationDelay}
    >
      <div className="space-y-4">
        {/* Stats row */}
        <div className="grid grid-cols-3 gap-2 text-center">
          <div className="bg-muted/50 rounded-lg px-2 py-3">
            <div className="text-muted-foreground flex items-center justify-center gap-1">
              <Clock className="size-3.5" />
            </div>
            <p className="text-foreground mt-1 text-xl font-bold">
              {stats.dueCount}
            </p>
            <p className="text-muted-foreground text-xs">Due</p>
          </div>
          <div className="bg-muted/50 rounded-lg px-2 py-3">
            <div className="text-muted-foreground flex items-center justify-center gap-1">
              <Sparkles className="size-3.5" />
            </div>
            <p className="text-foreground mt-1 text-xl font-bold">
              {stats.totalCount}
            </p>
            <p className="text-muted-foreground text-xs">Total</p>
          </div>
          <div className="bg-muted/50 rounded-lg px-2 py-3">
            <div className="text-muted-foreground flex items-center justify-center gap-1">
              <Target className="size-3.5" />
            </div>
            <p className="text-foreground mt-1 text-xl font-bold">
              {stats.masteredCount}
            </p>
            <p className="text-muted-foreground text-xs">Mastered</p>
          </div>
        </div>

        {/* Progress bar */}
        <div className="space-y-1.5">
          <div className="flex items-center justify-between text-xs">
            <span className="text-muted-foreground">Mastery</span>
            <span className="text-foreground font-medium">
              {masteryPercentage}%
            </span>
          </div>
          <Progress value={masteryPercentage} className="h-2" />
        </div>
      </div>
    </FeatureCard>
  )
}
